export enum OrderByDirection {
    Asc = "Asc",
    Desc = "Desc",
}